import axios from 'axios';
import { useEffect, useState } from 'react';

const SentimentResult = ({ reviews }) => {
  const [sentiment, setSentiment] = useState(null);

  useEffect(() => {
    if (reviews.length > 0) {
      axios.post('/sentiment', {
        reviews: reviews.map(r => r.comment) 
      }).then(res => {
        setSentiment(res.data);
      });
    }
  }, [reviews]);

  if (!sentiment) return <p>Analyzing sentiment...</p>;

  return (
    <div>
      <img 
        src={`data:image/png;base64,${sentiment.pie_chart_base64}`} 
        alt="Sentiment Distribution Pie Chart"
        style={{width: '300px', height: '300px'}}
      />
      <ul>
        {Object.entries(sentiment.distribution).map(([label, count]) => (
          <li key={label}>{label}: {count}</li>
        ))}
      </ul>
    </div>
  );
};

export default SentimentResult;
